import { GET_CONTENT, GET_FAQS } from "../actions/types";

const initialState = {
  content: [],
};

export default function contentReducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case GET_CONTENT:
      return {
        ...state,
        content: action.content,
      };
    default:
      return {
        ...state,
      };
  }
}
